import { StepPlaceholder } from '../../../StepPlaceholder/StepPlaceholder';

export const PersonalGuaranteePage = () => {
    return <StepPlaceholder />;
};
